import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import LockIcon from "@material-ui/icons/Lock";
import { makeStyles, withStyles, CircularProgress, Box, Typography } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { useHistory } from "react-router-dom";
import { useTranslate } from "react-polyglot";
import { useBaseData } from "../Providers/Data/BaseDataProvider.jsx";
import FlexboxHorizontal from "./FlexboxHorizontal.jsx";

const useStyles = makeStyles({
  mainBox: {
    width: 632,
    marginLeft: "auto",
    marginRight: "auto",
    alignItems: "center",
    justifyContent: "space-between",
  },
  langIcon: {
    margin: "0 10px 0 0",
  },
  expandIcon: {
    margin: "0 0 0 10px",
  },
  progressBox: {
    backgroundColor: "#fff",
    borderRadius: "50%",
    "&.MuiCircularProgress-colorPrimary": {
      color: "#26323C",
    },
    "& .MuiCircularProgress-svg": {
      "& circle": {
        strokeWidth: 2,
      },
    },
  },
  progressMainBox: {
    "& .MuiTypography-root": {
      color: "#26323C",
      fontSize: 12,
      fontWeight: 500,
    },
  },
  course: {
    color: "#54606B",
    fontSize: 12,
    marginBottom: 4,
  },
});

const StyledTextButton = withStyles({
  root: {
    color: "#1B1C1C",
    textTransform: "none",
    padding: 0,
    fontSize: 16,
    fontWeight: 600,
  },
})(Button);

const StyledMenu = withStyles({
  paper: {
    minWidth: 150,
    maxWidth: 632,
  },
})(Menu);

const StyledMenuItem = withStyles({
  root: {
    whiteSpace: "wrap",
  },
})(MenuItem);

/**
 * @param {Object} buttonProps
 * @param {Object} menuProps
 * @return {*}
 * @constructor
 */
const CourseSelect = ({ buttonProps, menuProps }) => {
  const { availableSubjects, subject, chooseSubject } = useBaseData();
  const history = useHistory();
  const t = useTranslate();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentSubject, setCurrentSubject] = useState(null);

  useEffect(() => {
    if (subject && availableSubjects)
      setCurrentSubject(availableSubjects.find((item) => item.id === subject.subjectId));
  }, [availableSubjects, subject]);

  /** @param {Event} event */
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /** */
  const handleClose = () => {
    setAnchorEl(null);
  };

  /** @param {CompanySubject} subj */
  const onSubjectSelected = (subj) => {
    if (!subj.available) return;
    chooseSubject(subj.id).then();
    handleClose();
    if (window.location.pathname.startsWith("/learn/")) {
      history.replace("/");
    }
  };

  const addedSubjects =
    (availableSubjects && availableSubjects.filter((subj) => subj.added === true || subj.added === undefined)) || [];

  const currentCourse = (availableSubjects && availableSubjects.find((subj) => subj.id === subject.subjectId)) || {
    name: "",
  };

  return (
    <FlexboxHorizontal data-tag="center" className={classes.mainBox}>
      <Box>
        <Typography className={classes.course}>{t("course")}</Typography>
        <StyledTextButton {...buttonProps} size="small" onClick={handleClick}>
          {currentCourse.name}
          <ExpandMoreRoundedIcon className={classes.expandIcon} />
        </StyledTextButton>
        <StyledMenu
          id="lang-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          {...menuProps}
        >
          {addedSubjects.map((subject) => (
            <StyledMenuItem key={subject.id} onClick={() => onSubjectSelected(subject)}>
              {!subject.available ? (
                <LockIcon style={{ color: "#C5C7C9", fontSize: 14, marginRight: 8 }} />
              ) : (
                <span style={{ marginRight: 8, color: "#C5C7C9" }}>•</span>
              )}
              {subject.name}
            </StyledMenuItem>
          ))}
        </StyledMenu>
      </Box>
      <Box className={classes.progressMainBox} position="relative" display="inline-flex">
        <CircularProgress
          className={classes.progressBox}
          variant="determinate"
          value={currentSubject?.courseProgress}
        />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {currentSubject?.courseProgress >= 0 && (
            <Typography variant="caption" component="div">{`${Math.round(
              currentSubject?.courseProgress,
            )}%`}</Typography>
          )}
        </Box>
      </Box>
    </FlexboxHorizontal>
  );
};

CourseSelect.propTypes = {
  buttonProps: PropTypes.object,
  menuProps: PropTypes.object,
};

export default CourseSelect;

// "'•'";
